import React from 'react';
import { SubHeading } from '../../components';
import { images, data } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const AwardCard = ({ award: { imgUrl, title, subtitle } }) => {
  return (
    <div className='app__laurels_awards-card'>
        <img src={imgUrl} alt='award' />
        <div className='app__laurels_awards-card_content' >
          <p className='p__cormorant' >{title}</p>
          <p className='p__cormorant' >{subtitle}</p>
        </div>
    </div>
  )
}

const Laurels = () => {

    return (
      <div className='app__laurel app__wrapper section__padding ' >
        <div>
          <SubHeading title='Awards & Recognition' />
          <h1 className='headtext__cormorant' >Our Laurels</h1>
        </div>
          <div className='app__laurels_info' >
            <div className='app__laurels_awards' >
              {
                data.awards.map( (award) => {
                  return <AwardCard key={award.title} award={award} />
                } )
              }
            </div>
            <div className='app__laurels_img' >
              <LazyLoadImage effect='blur' src={images.laurels} alt='laurels' />
            </div>
          </div>
      </div>
  );
} 

export default Laurels;
